import { render, staticRenderFns } from "./NewCreateAulaInfantil.vue?vue&type=template&id=4805f53d&scoped=true"
import script from "./NewCreateAulaInfantil.vue?vue&type=script&lang=js"
export * from "./NewCreateAulaInfantil.vue?vue&type=script&lang=js"
import style0 from "./NewCreateAulaInfantil.vue?vue&type=style&index=0&id=4805f53d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4805f53d",
  null
  
)

export default component.exports